import React, { useContext, useState } from "react";
import AdvisorNavbar from "../layout/AdvisorNavbar";
import LocContext from "../context/locContext";
import { FiDownload, FiTrendingUp, FiCalendar, FiFileText, FiCheckCircle } from "react-icons/fi";
import { NavLink } from "react-router-dom";

export default function Commissions() {
  const { userData } = useContext(LocContext);
  const [filterPeriod, setFilterPeriod] = useState("all");

  const formatINR = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const [commissionData] = useState({
    totalEarnings: 245000,
    expectedThisMonth: 45000,
    paidThisMonth: 30000,
    pendingAmount: 15000,
    totalClients: 24,
    averageCommission: 10208,
  });

  const [statements] = useState([
    {
      id: 1,
      period: "January 2024",
      expected: 45000,
      paid: 45000,
      status: "Paid",
      payoutDate: "2024-02-05",
      tax: 4500,
      gst: 8100,
      netAmount: 32400,
    },
    {
      id: 2,
      period: "December 2023",
      expected: 38000,
      paid: 38000,
      status: "Paid",
      payoutDate: "2024-01-05",
      tax: 3800,
      gst: 6840,
      netAmount: 27360,
    },
    {
      id: 3,
      period: "November 2023",
      expected: 42000,
      paid: 42000,
      status: "Paid",
      payoutDate: "2023-12-05",
      tax: 4200,
      gst: 7560,
      netAmount: 30240,
    },
  ]);

  const [payoutSchedule] = useState([
    { id: 1, period: "February 2024", expectedAmount: 45000, payoutDate: "2024-03-05", status: "Pending" },
    { id: 2, period: "March 2024", expectedAmount: 50000, payoutDate: "2024-04-05", status: "Upcoming" },
  ]);

  const handleDownloadStatement = (statementId) => {
    alert(`Downloading statement for ${statementId}`);
  };

  return (
    <>
    <AdvisorNavbar />
    <div className="page-content" style={{ background: "#f1f5f9" }}>
   
          {/* Header */}
          <div className="card shadow-sm p-4 mb-4" style={{ borderRadius: "12px" }}>
            {/* <div style={{
              background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)",
              padding: "20px",
              borderRadius: "12px",
              borderBottom: "3px solid #39b2b4",
            }}> */}
              <div className="d-flex align-items-center">
           
                <div>
                  <h2 className="mb-1">
                    Commissions
                  </h2>
               <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/agent/dashboard">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">Commissions</li>
                </ol>
              </nav>  
                </div>
              </div>
            {/* </div> */}
          </div>

          {/* Summary Cards */}
          <div className="row g-3 mb-4">
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card shadow-sm h-100" style={{ borderRadius: "12px", border: "none", overflow: "hidden" }}>
                <div className="card-body p-4" style={{
                  background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)",
                  borderLeft: "4px solid #",
                }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <p className="mb-1" style={{ color: "#64748b", fontSize: "14px", fontWeight: "500" }}>Total Earnings</p>
                      <h3 className="mb-0" style={{ color: "#" }}>
                        {formatINR(commissionData.totalEarnings)}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="card shadow-sm h-100" style={{ borderRadius: "12px", border: "none", overflow: "hidden" }}>
                <div className="card-body p-4" style={{
                  background: "linear-gradient(135deg, #ffffff 0%, #f0fdf4 100%)",
                  borderLeft: "4px solid #10b981",
                }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <p className="mb-1" style={{ color: "#64748b", fontSize: "14px", fontWeight: "500" }}>Expected This Month</p>
                      <h3 className="mb-0" style={{ color: "#10b981" }}>
                        {formatINR(commissionData.expectedThisMonth)}
                      </h3>
                    </div>
                    <FiTrendingUp style={{ fontSize: "28px", color: "#10b981" }} />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="card shadow-sm h-100" style={{ borderRadius: "12px", border: "none", overflow: "hidden" }}>
                <div className="card-body p-4" style={{
                  background: "linear-gradient(135deg, #ffffff 0%, #fff7ed 100%)",
                  borderLeft: "4px solid #f59e0b",
                }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <p className="mb-1" style={{ color: "#64748b", fontSize: "14px", fontWeight: "500" }}>Pending Amount</p>
                      <h3 className="mb-0" style={{ color: "#f59e0b" }}>
                        {formatINR(commissionData.pendingAmount)}
                      </h3>
                    </div>
                    <FiCalendar style={{ fontSize: "28px", color: "#f59e0b" }} />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Payout Schedule */}
          <div className="card shadow-sm mb-4" style={{ borderRadius: "12px", border: "none" }}>
            <div className="card-body p-4">
              <div style={{
                background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)",
                padding: "16px",
                borderRadius: "12px",
                borderBottom: "3px solid #39b2b4",
                marginBottom: "24px",
              }}>
                <h4 className="mb-0" >
                  Payout Schedule
                </h4>
              </div>

              <div className="row g-3">
                {payoutSchedule.map((payout) => (
                  <div key={payout.id} className="col-12 col-md-6">
                    <div className="card" style={{
                      borderRadius: "12px",
                      border: payout.status === "Pending" ? "2px solid #f59e0b" : "1px solid #e2e8f0",
                      background: payout.status === "Pending" ? "#fff7ed" : "#ffffff",
                    }}>
                      <div className="card-body p-4">
                        <div className="d-flex justify-content-between align-items-start mb-3">
                          <div>
                            <h6 className="mb-1" style={{ color: "#1e293b", fontSize: "16px", fontWeight: "600" }}>
                              {payout.period}
                            </h6>
                            <p className="mb-0" style={{ color: "#64748b", fontSize: "13px" }}>
                              Expected: {formatINR(payout.expectedAmount)}
                            </p>
                          </div>
                          <span className="badge" style={{
                            background: payout.status === "Pending" ? "#fef3c7" : "#dbeafe",
                            color: payout.status === "Pending" ? "#f59e0b" : "#2563eb",
                            padding: "6px 12px",
                            borderRadius: "6px",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}>
                            {payout.status}
                          </span>
                        </div>
                        <div className="d-flex align-items-center" style={{ color: "#64748b", fontSize: "13px" }}>
                          <FiCalendar style={{ fontSize: "14px", marginRight: "4px" }} />
                          <span>Payout Date: {new Date(payout.payoutDate).toLocaleDateString()}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Commission Statements */}
          <div className="card shadow-sm" style={{ borderRadius: "12px", border: "none" }}>
            <div className="card-body p-4">
              <div style={{
                background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)",
                padding: "16px",
                borderRadius: "12px",
                borderBottom: "3px solid #39b2b4",
                marginBottom: "24px",
              }}>
                <h4 className="mb-0" >
                  Commission Statements
                </h4>
              </div>

              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr style={{ background: "#f8fafc" }}>
                      <th style={{ color: "#", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Period</th>
                      <th style={{ color: "#", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Expected</th>
                      <th style={{ color: "#", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Paid</th>
                      <th style={{ color: "#", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Tax</th>
                      <th style={{ color: "#", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>GST</th>
                      <th style={{ color: "#", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Net Amount</th>
                      <th style={{ color: "#", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Status</th>
                      <th style={{ color: "#", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {statements.map((statement) => (
                      <tr key={statement.id} style={{ borderBottom: "1px solid #e2e8f0" }}>
                        <td style={{ padding: "12px", color: "#1e293b", fontWeight: "500" }}>{statement.period}</td>
                        <td style={{ padding: "12px", color: "#1e293b" }}>{formatINR(statement.expected)}</td>
                        <td style={{ padding: "12px", color: "#1e293b", fontWeight: "600" }}>{formatINR(statement.paid)}</td>
                        <td style={{ padding: "12px", color: "#64748b" }}>{formatINR(statement.tax)}</td>
                        <td style={{ padding: "12px", color: "#64748b" }}>{formatINR(statement.gst)}</td>
                        <td style={{ padding: "12px", color: "#", fontWeight: "600" }}>{formatINR(statement.netAmount)}</td>
                        <td style={{ padding: "12px" }}>
                          <span className="badge" style={{
                            background: "#d1fae5",
                            color: "#10b981",
                            padding: "6px 12px",
                            borderRadius: "6px",
                            fontSize: "12px",
                            fontWeight: "600",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            width: "fit-content",
                          }}>
                            <FiCheckCircle style={{ fontSize: "12px" }} />
                            {statement.status}
                          </span>
                        </td>
                        <td style={{ padding: "12px" }}>
                          <button
                            className="btn btn-sm"
                            onClick={() => handleDownloadStatement(statement.id)}
                            style={{
                              background: "linear-gradient(135deg, #ccf1f7 0%, #b3eaf4 100%)",
                              color: "#",
                              border: "none",
                              borderRadius: "6px",
                              padding: "6px 12px",
                              fontSize: "12px",
                              fontWeight: "500",
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <FiDownload style={{ fontSize: "14px" }} />
                            Download
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
    </>
    );
}
